// extracted by mini-css-extract-plugin
export var addToCartss = "FrequentProducts-module--addToCartss--6befc";
export var root = "FrequentProducts-module--root--424cc";